import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MojoFeatureExtensionsService } from 'mojo-feature-extensions';
import { of } from 'rxjs';
import { filter, map, shareReplay, switchMap, take } from 'rxjs/operators';
import {
  AddCandidateModalComponent,
  AddCandidateModalData,
} from '@shared/candidate/side-nav-candidate/components/talent-pool-add-candidate-modal/add-candidate-modal.component';
import { MojoBatchService } from 'mojo-batch';
@Component({
  selector: 'mojo-batch-operation-add-candidates-to-talent-pool',
  templateUrl: './batch-operation-add-candidates-to-talent-pool.component.html',
  styleUrls: ['./batch-operation-add-candidates-to-talent-pool.component.scss'],
})
export class BatchOperationAddCandidatesToTalentPoolComponent {
  disabled$ = this.selectionManagerService.selection$.pipe(
    map((selection) => selection.length === 0),
    shareReplay(1),
  );

  constructor(
    private selectionManagerService: MojoBatchService,
    private dialog: MatDialog,
    public featureExtensionsService: MojoFeatureExtensionsService,
  ) {}

  onBtnClick() {
    this.disabled$
      .pipe(
        switchMap((disabled) => (disabled ? of([]) : this.selectionManagerService.selection$)),
        take(1),
        filter((items) => items.length > 0),
      )
      .subscribe((candidateIds: string[]) =>
        this.openModal(candidateIds.filter((id) => !!id).map((id) => +id)),
      );
  }

  private openModal(candidateIds: number[]) {
    this.selectionManagerService.clearSelection();
    this.dialog.open<AddCandidateModalComponent, AddCandidateModalData>(
      AddCandidateModalComponent,
      {
        panelClass: 'medium-size-modal',
        disableClose: true,
        data: {
          candidateIds,
        },
      },
    );
  }
}
